(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-collection-catalog"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionFilters(root) {
    const toggle = root.querySelector('[data-filter-toggle]');
    const panel = root.querySelector('[data-filters]');
    if (!toggle || !panel || toggle.dataset.initialized) return;
    toggle.dataset.initialized = 'true';
    toggle.setAttribute('role', 'button');
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
    });
    toggle.addEventListener('keydown', (event) => {
      if (event.key === ' ') { event.preventDefault(); toggle.click(); }
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }
  document.querySelectorAll('.dd-cc').forEach(initializeCollectionFilters);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.dd-cc').forEach(initializeCollectionFilters);
  });

  } catch(e) { console.error(e); }
})();
})();
